export class RealtimeConfigurationError extends Error {
  constructor(message) {
    super(message);
    this.name = "RealtimeConfigurationError";
    this.code = "REALTIME_CONFIG_INVALID";
  }
}

function parsePort(value, fallback) {
  const port = Number(value || fallback);
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    throw new RealtimeConfigurationError("Nieprawidłowy port Reverb.");
  }
  return port;
}

function defaultAuthEndpoint(env, location) {
  if (env.VUE_APP_REVERB_AUTH_ENDPOINT) return env.VUE_APP_REVERB_AUTH_ENDPOINT;

  const apiUrl = env.VUE_APP_API_URL?.replace(/\/$/, "");
  if (apiUrl) return `${apiUrl}/broadcasting/auth`;

  return `${location.origin}/api/broadcasting/auth`;
}

export function createEchoOptions({ env, location, token }) {
  const key = env.VUE_APP_REVERB_APP_KEY?.trim();
  if (!key) {
    throw new RealtimeConfigurationError("Brak VUE_APP_REVERB_APP_KEY.");
  }

  const scheme = env.VUE_APP_REVERB_SCHEME || (location.protocol === "https:" ? "https" : "http");
  const forceTLS = scheme === "https" || scheme === "wss";
  const port = parsePort(env.VUE_APP_REVERB_PORT, forceTLS ? 443 : 8111);
  const path = env.VUE_APP_REVERB_PATH?.trim();

  const options = {
    broadcaster: "reverb",
    key,
    wsHost: env.VUE_APP_REVERB_HOST || location.hostname,
    wsPort: port,
    wssPort: port,
    forceTLS,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    authEndpoint: defaultAuthEndpoint(env, location),
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    },
  };

  if (path) options.wsPath = path;

  return options;
}
